import httpClient from './httpClient'

const END_POINT = '/api/prematriculas_alumnos'

const updatePrematriculaNivel = async (item) => {
  let idNivel = item.nivel.id || null
  return await httpClient.put(`${END_POINT}/${item.id}`, { nivel: idNivel }) 
}

export {
  updatePrematriculaNivel,
}